export default __webpack_public_path__ + "static/media/hover-imatge-respectant@2x.2dd6c190.jpg";